
<div class="card-container" [style.backgroundColor]="authorCard.color">
  <div class="card-format" [style.height.px]="cardSizeScaled">
    <div class="card-content-container" fxLayout="column" [style.transform]="scaleCard" (click)="goToInfo()">
      <div class="card-date">{{ authorCard.id }}</div>
      <div class="card-title" [matTooltip]="authorCard.name">
       
          <div>{{ authorCard.name }}</div>

      </div>

      <div class="card-category">{{ authorCard.biography }}</div>
      <div fxFlex></div>
 
    </div>


  </div>
</div>
